(function componentForm($, Adzuki)
{
	'use strict';

	var form = {
		name: 'InsurancePurchase',
	};

	var label_name         = 'insurancepurchase';
	var choose_cc          = null;
	var choose_cc_type     = null;
	var cc_info_section    = null;
	var cc_billing_section = null;
	var choose_country     = null;
	var add_cc_to_profile  = null;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		choose_cc          = $('#' + label_name + '-client_credit_card_id');
		choose_cc_type     = $('#' + label_name + '-credit_card_type_id');
		cc_info_section    = $('.cc-info');
		cc_billing_section = $('.billing-info');
		choose_country     = $('#' + label_name + '-cardholder_country_id');
		add_cc_to_profile  = $('.add-cc-to-profile');

		// when choosing a credit card
		choose_cc.change(changeCreditCard);

		// when choosing a credit card type
		choose_cc_type.change(changeCreditCardType);

		// when the select drop down of cardholder country changes
		choose_country.change(changeCountry);

		// check for changes in these fields, if they are changed, show that "Add to Profile" checkbox
		$('.change-field').change(function onChangeField(event, trigger_changed)
		{
			if (trigger_changed) {
				return;
			}

			add_cc_to_profile.removeClass('hidden');
		});

		$('#' + label_name + '-credit_card_expiration').on('dp.change', function onDateTimePickerChange(event)
		{
			if (event.oldDate === null) {
				return;
			}

			add_cc_to_profile.removeClass('hidden');
		});
	};

	function changeCreditCard(event)
	{
		var credit_card_id  = $(this).val();
		var url             = '/Clients/getClientCreditCardInfo/' + credit_card_id;

		if (credit_card_id) {
			showCCFields();
			add_cc_to_profile.addClass('hidden');

			if (credit_card_id === 'other') {
				clearFields();
				add_cc_to_profile.removeClass('hidden');
				return;
			}

			// populate CC fields
			Adzuki.Ajax.get(url).then(function getCreditCardSuccess(credit_card)
			{
				var exp_date  = moment(credit_card.expiration, 'YYYY-MM-DD');
				var exp_year  = exp_date.year();
				var exp_month = exp_date.month() + 1;

				clearFields();

				if (exp_month < 10) {
					exp_month = '0' + String(exp_month);
				}

				// pre-populate country and state
				$('#' + label_name + '-cardholder_country_id')
					.val(credit_card.country_id)
					.trigger('change', [credit_card.state_id]);

				$('#' + label_name + '-cardholder_name').val(credit_card.name);
				$('#' + label_name + '-credit_card_type_id').val(credit_card.credit_card_type_id);
				$('#' + label_name + '-credit_card_type_id').trigger('change', [true]);
				$('#' + label_name + '-credit_card_number').val('');
				$('#' + label_name + '-cardholder_address1').val(credit_card.address1);
				$('#' + label_name + '-cardholder_city').val(credit_card.city);
				$('#' + label_name + '-cardholder_zipcode').val(credit_card.zip);

				if (credit_card.address2) {
					$('#' + label_name + '-cardholder_address2').val(credit_card.address2);
				}

				if (Adzuki.is_mobile) {
					$('#' + label_name + '-credit_card_expiration').val(exp_year + '-' + exp_month + '-01');
				} else {
					$('#' + label_name + '-credit_card_expiration')
						.data('DateTimePicker')
						.date(moment(exp_year + '-' + exp_month + '-01', 'YYYY-MM-DD'));
				}

				// for AMEX cards, pre-select the AMEX card type
				if (parseInt(credit_card.credit_card_type_branch_id)) {
					$('#' + label_name + '-credit_card_type_branch_id')
						.val(credit_card.credit_card_type_branch_id);
				}
			});
		} else {
			hideCCFields();
		}
	}

	function changeCountry(event, state_id)
	{
		var country_id = $(this).val();

		Adzuki.Ajax.get('/States/getByCountryId/' + country_id).then(function onStatesSuccess(states)
		{
			$('#' + label_name + '-cardholder_state_id')
				.empty()
				.append('<option selected="1"></option>');

			$.each(states, function onEachState(id, state_name) {
				var markup = '';
				markup += '<option value="' + id + '">';
				markup += state_name;
				markup += '</option>';

				$('#' + label_name + '-cardholder_state_id').append(markup);
			});

			if (state_id) {
				$('#' + label_name + '-cardholder_state_id').val(state_id);
			}
		});
	}

	function changeCreditCardType(event)
	{
		var credit_card_type = parseInt($(this).val());

		if (credit_card_type === 1) {
			$('.amex-card-type').removeClass('hidden');
		} else {
			$('.amex-card-type').addClass('hidden');
			$('#' + label_name + '-credit_card_type_branch_id').val('');
		}
	}

	function clearFields()
	{
		$('#' + label_name + '-cardholder_name').val('');
		$('#' + label_name + '-credit_card_type_id').val('');
		$('#' + label_name + '-credit_card_type_branch_id').val('');
		$('#' + label_name + '-credit_card_number').val('');
		$('#' + label_name + '-cardholder_address1').val('');
		$('#' + label_name + '-cardholder_address2').val('');
		$('#' + label_name + '-cardholder_city').val('');
		$('#' + label_name + '-cardholder_state_id').val('');
		$('#' + label_name + '-cardholder_zipcode').val('');
		$('#' + label_name + '-cardholder_country_id').val('183');
		$('#' + label_name + '-credit_card_expiration').val('');
	}

	function showCCFields()
	{
		cc_info_section.removeClass('hidden');
		cc_billing_section.removeClass('hidden');
	}

	function hideCCFields()
	{
		cc_info_section.addClass('hidden');
		cc_billing_section.addClass('hidden');
	}
}(jQuery, window.Adzuki || {}));
